import SignPdfModal from './sign-pdf-modal';

export default SignPdfModal;
